import CopiedSVG from '@components/icons/copiedIcon.svg';
import CopiedMobileSVG from '@components/icons/copiedMobileIcon.svg';
import styled from 'styled-components';

export const CopiedWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(243, 243, 243, 0.85);
`;

export const CopiedText = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: 0.75rem;
  line-height: 130%;
  color: ${({ theme }) => theme.colors.title};
`;

export const CopiedIcon = styled(CopiedSVG)`
  flex-shrink: 0;
  margin-right: 0.5rem;
`;

export const CopiedMobileIcon = styled(CopiedMobileSVG)`
  flex-shrink: 0;
`;
